import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

export const apiUrlInterceptor: HttpInterceptorFn = (request, next) => {
  const lang = inject(TranslateService).currentLang() || 'en';

  return next(
    addApiUrl(request).clone({
      setHeaders: {
        'Accept-Language': lang,
      },
    }),
  );
};

function addApiUrl(request: HttpRequest<unknown>): HttpRequest<unknown> {
  const token = sessionStorage.getItem(environment.tokenKey);
  if (
    request.url.includes('http') ||
    request.url.includes('https') ||
    request.url.includes('i18n')
  ) {
    return request;
  }
  if (
    !request.url.includes('login/') &&
    !request.url.includes('password_reset/') &&
    !request.url.includes('check_password_reset_token') &&
    !request.url.includes('password_reset_confirm')
  ) {
    return request.clone({
      url: `${environment.apiUrl}${request.url}`,
      setHeaders: {
        Authorization: `Token ${token}`,
      },
    });
  }
  return request.clone({
    url: `${environment.apiUrl}${request.url}`,
  });
}
